import React, { useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import './style.css';

//JACK-TODO: onchnage setTimeout 500~1000 => call POST /es/wordpress {query: "keyword"}

const SearchBar = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { t, i18n } = useTranslation();
    const useChinese = i18n.language === 'zhTW' || i18n.language === 'cn';
    // const [keyword, setKeyword] = useState('');
    const [timeoutMethod, setTimeoutMethod] = useState(setTimeout(() => {}, 0));
    const delayedSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const keywordValue = event.target.value;
        if(props.onChange) {
            if(timeoutMethod) {
                clearTimeout(timeoutMethod);
            }
            setTimeoutMethod(setTimeout(() => {
                props.onChange(keywordValue, () => setLoading(false));
                setLoading(true);
            }, 1000));
        }
        event.preventDefault();
    }

    return (
        <div className="search-container" style={props.isMobile ? { width: '100%'} : {}}>
            <input
                // value={keyword}
                className="search-bar"
                placeholder={t('keywordSearch')}
                spellCheck={false}
                onChange={delayedSearch}
                style = {{...(useChinese ? { fontFamily: 'Microsoft JhengHei' } : { fontFamily: 'Rambla' }),}}
            />
            {loading &&
                <Spinner animation="border" size="sm" variant="secondary" />
            }
        </div>
    );
}

export default SearchBar;